import { Button, Container } from '@mui/material';
import { NavLink } from "react-router-dom";

import { useUserContext } from "../../../contexts/userContext";

import PermissionGate from "../../permissionGate";
import Navigation from "../../header";
import { Icons } from '../../icons';
import MaterialInventoryDetailsForm from '../../forms/materialInventoryDetailsForm';


const MaterialInventoryAdd = () => {
	const userContext = useUserContext();

	return (
		<div className="hwi-material-inventory-add">
			<Navigation></Navigation>
			<Container maxWidth="lg" className="route-container">
				<PermissionGate permission={userContext.permissions?.canManageMaterialInventory}>
					<section className="management-page-header">
						<div className="title">
							<NavLink to="/materialinventory" className="back-link">
								<Icons.GoBack fill="#9399ad" height="24px"></Icons.GoBack>
							</NavLink>
							Add Material Inventory
						</div>
					</section>
					<section className="management-page-form">
						<MaterialInventoryDetailsForm></MaterialInventoryDetailsForm>
					</section>
				</PermissionGate>
			</Container>
		</div>
	);
};

export default MaterialInventoryAdd;